// extracted by mini-css-extract-plugin
export default {"sms":"JYa30"};